export default "__VITE_ASSET__D$YHCqI0__"